import React, { useState } from 'react';
import clsx from 'clsx';
import {
    Button, Popover, Icons, LinkButton, AnchorLinkButton
} from 'components';

import './style.scss';
import { LinksListUL } from './inks-list';

export interface ILinksControl {
    className?: string;
}

export const LinksControl: React.FC<ILinksControl> = (props): JSX.Element => {
    const { className = '' } = props;

    const [ referenceElement, setReferenceElement ] = useState(null);
    const [ showPopover, setShowPopover ] = useState(false);

    return (
        <React.Fragment>
            <Button
                className="links-button"
                variant='black'
                ref={setReferenceElement}
                onClick={() => setShowPopover(true)}
                onMouseEnter={() => setShowPopover(true)}
                onMouseLeave={() => setShowPopover(false)}
                icon={<Icons.IconQuestionMark />}
            />
            <Popover
                hideTimeout={300}
                showTimeout={300}
                targetElement={referenceElement}
                offset={[ 0, 4 ]}
                placement="left-start"
                open={showPopover}
            >
                <LinksListUL />
            </Popover>
        </React.Fragment>
    );
};
